<template>
  <CampaignSkeleton v-if="loading" />
  <div v-else class="card">
    <div class="card-campaign">
      <div
        class="card-campaign-content"
        v-for="(item, index) in campaignData.htmlInventoryDtos"
        :key="index"
      >
        <span v-html="item.htmlContent"></span>
      </div>
    </div>
    <div class="card-slider">
      <CampaignSlider
        image-height="220px"
        :items="campaignData.bannerInventoryDtos || []"
      />
    </div>
  </div>
</template>

<script>
import CampaignSlider from '@/components/CampaignCard/CampaignSlider';
import CampaignSkeleton from '@/components/CampaignCard/CampaignSkeleton';

export default {
  name: 'CampaignCard',
  components: {
    CampaignSlider,
    CampaignSkeleton,
  },
  props: {
    campaignData: {
      type: Object,
      required: true,
    },
    millisecs: {
      type: Number,
      required: false,
    },
    loading: {
      type: Boolean,
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/assets/styles/variables.scss';

.card {
  display: flex;
  justify-content: center;
  align-items: center;

  &-campaign {
    width: 50%;
    margin: 0 10px 0 20px;
    height: 305px;
    overflow-y: auto;

    &-content {
      width: 100%;
      min-height: 85px;
      margin: 13px 0;
      padding: 12px 21px 11px 12px;
      border-radius: 10px;
      background-color: $colorN10;
      overflow-x: scroll;
    }
  }

  &-slider {
    width: 50%;
    height: auto;
    margin: 0 20px 0 10px;
  }
}
@media screen and (max-width: 415px) {
  .card {
    flex-direction: column;
  }
  .card-campaign {
    width: 100%;
    margin: 0;
  }
  .card-slider {
    width: 100%;
    margin: 0;
  }
}
</style>
